import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { DrillsService } from '@drills/infra';

export class ToggleFavoriteCommandHandler {
  private readonly drillsService: DrillsService = inject(DrillsService);

  execute(drillId: string): Observable<void> {
    return this.drillsService.toggleFavorite(drillId).pipe(map(() => void 0));
  }
}
